var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.label)?_c('label',{staticClass:"label--style",attrs:{"for":_vm.labelFor}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('textarea',{staticClass:"form--control",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"rows":"4"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }